var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('alertStep',{attrs:{"useDefault":true,"useDefaultNumber":1}}),_vm._v(" "),_c('form-text-box',{ref:"rentInfoBox",attrs:{"dataList":_vm.rentInfo_formConfig,"rules":_vm.rentInfo_formRule,"model":_vm.rentInfo_model,"column":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }